module.exports = __webpack_public_path__ + "static/img/egg_g_03.7b04834.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_03.png
// module id = iwV4
// module chunks = 1